export default class ListData<T>{
    constructor(currentPage: number = 1, pageSize: number = 10) {
        this.currentPage = currentPage;
        this.pageSize = pageSize;
    }
    totalCount: number = 0;
    currentPage: number;
    pageSize: number;
    list: Array<T> = new Array<T>();
    loading: boolean = false;
}